/**
 * Phase 3 — Repeating section grouping for forms.
 *
 * Mirrors the backend `_group_fields_into_sections` in /app/backend/routes/forms.py
 * so editor, office, mobile-tech, and customer review all see the same shape.
 *
 * Returns groups in document order:
 *   { section: <field|null>, repeatable: bool, label: string|null,
 *     max: number|null, fields: [<field>] }
 *
 * Data shape contract:
 *   data_json[<section.field_key>] = [
 *     { <child.field_key>: <value>, ... },   // instance 0
 *     { ... },                                // instance 1
 *   ]
 */

export const REPEAT_DEFAULT_MAX = 20;
export const REPEAT_HARD_CAP = 50;

export function groupFieldsIntoSections(fields) {
  const groups = [];
  let current = { section: null, repeatable: false, label: null, max: null, fields: [] };
  (fields || []).forEach(f => {
    if (f.field_type === 'section_header') {
      if (current.fields.length > 0 || current.section !== null) {
        groups.push(current);
      }
      const cfg = f.config || f.config_json || {};
      const isRep = !!cfg.repeatable;
      current = {
        section: f,
        repeatable: isRep,
        label: isRep ? (cfg.repeat_label || '') : null,
        max: isRep ? (cfg.max_instances || REPEAT_DEFAULT_MAX) : null,
        fields: [],
      };
    } else {
      current.fields.push(f);
    }
  });
  if (current.fields.length > 0 || current.section !== null) {
    groups.push(current);
  }
  return groups;
}

/** Read instances out of data for a repeatable group. Always returns a list. */
export function getInstances(data, sectionKey) {
  if (!data || !sectionKey) return [];
  const arr = data[sectionKey];
  return Array.isArray(arr) ? arr : [];
}

/** Build a new data dict with instances applied at sectionKey. */
export function setInstances(data, sectionKey, instances) {
  return { ...(data || {}), [sectionKey]: instances };
}
